import { useEffect, useState } from "react";
import { FaUserCircle, FaUserCheck } from "react-icons/fa";
import { MdPendingActions } from "react-icons/md";
import { PiHandDepositBold, PiListNumbersFill } from "react-icons/pi";
import { TbListNumbers } from "react-icons/tb";
import { AiOutlineCloseCircle } from "react-icons/ai";
import { GiGamepad } from "react-icons/gi";
import { IoMdStats } from "react-icons/io";
import { getAdminDashboardSummary } from "../Server/api";
import { useNavigate } from "react-router-dom";

// Helper function
function getValue(obj, key) {
  return obj?.[key] ?? 0;
}

// 💠 All Dashboard Cards
const cardConfig = [
  {
    label: "Total Users",
    route: "/all_users",
    key: "totalUsers",
    icon: <FaUserCircle size={36} className="text-white" />,
  },
  {
    label: "Active Users",
    route: "/active_users",
    key: "activeUsers",
    icon: <FaUserCheck size={36} className="text-white" />,
  },
  {
    label: "InActive Users",
    route: "/inactive_users",
    key: "InActive_User",
    icon: <FaUserCheck size={36} className="text-white" />,
  },
  {
    label: "Banned Users",
    key: "bannedUsers",
    icon: <AiOutlineCloseCircle size={36} className="text-white" />,
  },

  {
    label: "Total Deposit",
    key: "totalDeposit",
    route: "/admin_deposit_lists",
    icon: <PiHandDepositBold size={36} className="text-white" />,
  },
  {
    label: "Today Deposit",
    key: "todayDeposit",
    route: "/admin_deposite_report_datewise",
    icon: <PiHandDepositBold size={36} className="text-white" />,
  },

  {
    label: "Total Withdraw",
    key: "totalWithdraw",
    route: "/admin_withdrow_lists",
    icon: <TbListNumbers size={36} className="text-white" />,
  },
  {
    label: "Today Withdraw",
    key: "todayWithdraw",
    route: "/admin_withdrawal_report_datewise",
    icon: <TbListNumbers size={36} className="text-white" />,
  },

  {
    label: "Pending Amount",
    key: "pendingAmount",
    route: "/withdrawal_pending",
    icon: <MdPendingActions size={36} className="text-white" />,
  },
  // { label: "Pending Count", key: "pendingCount", route: "/withdrawal_pending", icon: <MdPendingActions size={36} className="text-white" /> },

  {
    label: "Approved Amount",
    key: "approvedAmount",
    route: "/withdrawal_complete",
    icon: <FaUserCheck size={36} className="text-white" />,
  },
  // { label: "Approved Count", key: "approvedCount", icon: <FaUserCheck size={36} className="text-white" /> },

  {
    label: "Rejected Amount",
    key: "rejectedAmount",
    route: "/withdrawal_reject",
    icon: <AiOutlineCloseCircle size={36} className="text-white" />,
  },
  // { label: "Rejected Count", key: "rejectedCount", icon: <AiOutlineCloseCircle size={36} className="text-white" /> },

  {
    label: "Total Bets",
    key: "totalBets",
    route: "/all_bets_lists",
    icon: <IoMdStats size={36} className="text-white" />,
  },
  // { label: "Today Transactions", key: "todayTransactions",route: "/userwallet", icon: <GiGamepad size={36} className="text-white" /> },
  // { label: "Total Transactions", key: "totalTransactions",route: "/userwallet", icon: <GiGamepad size={36} className="text-white" /> },
];

export default function Dashboard() {
  const [dashboardData, setDashboardData] = useState({});
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  useEffect(() => {
    fetchDashboardData();
  }, []);

  const fetchDashboardData = async () => {
    try {
      const res = await getAdminDashboardSummary();
      if (res?.data?.success) {
        setDashboardData(res.data.data);
      }
    } catch (err) {
      console.error("Error fetching dashboard summary:", err);
    } finally {
      setLoading(false);
    }
  };
  if (loading) {
    return (
      <div className="text-center mt-5">
        <h5>Loading dashboard data...</h5>
      </div>
    );
  }
  return (
    <div className="row g-3">
      {cardConfig.map((item, index) => (
        <div key={index} className="col-md-3 col-6">
          <div
            className="card shadow-sm primarycolor"
            style={{ cursor: "pointer" }}
            onClick={() => item.route && navigate(item.route)}
          >
            <div className="card-body d-flex align-items-center justify-content-between">
              <div>
                <h6 className="mb-1 text-white">{item.label}</h6>
                <h4 className="text-white">
                  {getValue(dashboardData, item.key)}
                </h4>
              </div>
              {item.icon}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
